var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"green","icon":""},on:{"click":function($event){return _vm.$emit('editClick', _vm.el)}}},[_c('v-icon',[_vm._v("edit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }